import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { errorHandler, getErrorMessage } from '../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';
import { CheckPermissionComponent } from '../../util/permission';
import { TICKET_LIST_ALL_DELETE } from '../../constants/menuPermissionConstant';
import API_TICKET_LIST from '../../api/apiTicketList';
import IconTrash from '../../assets/icons/IconTrash';
import Alert from '../Alert/Alert';
import ActionType from '../../redux/reducer/globalActionType';

class TicketDelete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showConfirmAlert: false,
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleCloseChatroom = () => {
        if (this.props.data.cs_client_id && this.props.data.pic_client_id) {
            const roomId = `${this.props.data.cs_client_id}_${this.props.data.ticket_no}_${this.props.data.pic_client_id}`;
            const data = {
                room_id: roomId,
                user_id: this.props.data.cs_client_id,
                ticket_id: this.props.data.id
            };
            return API_TICKET_LIST.postCloseChatroom(data, this.props.token);
        }
        return;
    }

    handleDeleteTicket = () => {
        const updatedAt = {
            updated_at: this.props.data.updated_at
        }

        API_TICKET_LIST.putDataDeleteTicket(updatedAt, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showConfirmAlert: false
                })
                setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                setTimeout(() => this.props.history.push(ROUTER_CONSTANT.TICKET_LIST_ALL), 1500)
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    handleConfirmDelete = async () => {
        await this.handleCloseChatroom();
        this.handleDeleteTicket();
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_DELETE]} userPermission={this.props.userDetail.permissions}>
                <button type="button" id="btndelete" className={(this.props.data.status === STATUS_TICKET_CONSTANT.UNASSIGNED || this.props.data.status === STATUS_TICKET_CONSTANT.ASSIGNED || this.props.data.status === STATUS_TICKET_CONSTANT.IN_PROGRESS || this.props.data.status === STATUS_TICKET_CONSTANT.ON_HOLD) && window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL) ? "bg-white text-darkblue flex items-center rounded-lg focus:outline-none py-2 px-5 mx-1" : "hidden"} onClick={() => this.setState({ showConfirmAlert: true })}>
                    <IconTrash />
                    <span className="ml-1">Hapus</span>
                </button>
                <Alert show={this.state.showConfirmAlert} icon="delete" button={true} title="Apakah Anda yakin menghapus tiket ini?" close={() => this.setState({ showConfirmAlert: false })} submit={() => this.handleConfirmDelete()} />
                <Alert show={this.state.showSuccessAlert} icon="success" title="Tiket berhasil dihapus!" />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TicketDelete));